import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { AreaComponent } from './widgets/area/area.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { CardComponent } from './widgets/card/card.component';
import { PieComponent } from './widgets/pie/pie.component';
import { MaterialModule } from '../Core/material.module';
import { ColumnChartComponent } from './widgets/column-chart/column-chart.component';
import { PageTitleComponent } from './widgets/page-title/page-title.component';
import { OnlyNumberDirective } from './directives/onlyNumber.directive';
import { NotifierModule } from "angular-notifier";
import { Config } from '../Core/config/config';
import { UserProfileComponent } from './widgets/user-profile/user-profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditProfileComponent } from './widgets/user-profile/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './widgets/user-profile/change-password/change-password.component';
import { AssignedLicencesComponent } from './widgets/user-profile/assigned-licences/assigned-licences.component';
import { SubscriptionComponent } from './widgets/user-profile/subscription/subscription.component';
import { DeleteConfirmationComponent } from './widgets/delete-confirmation/delete-confirmation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDailogComponent } from './widgets/confirm-dailog/confirm-dailog.component';
import { BannerComponent } from './widgets/banner/banner.component';
import { TwoDigitDecimaNumberDirective } from './directives/twoDigitDecimaNumber.directive';
import { UploadComponent } from './widgets/upload/upload.component';
import { TermConditionPageComponent } from './widgets/term-condition-page/term-condition-page.component';
import { SubscriptionPlanComponent } from './widgets/user-profile/subscription-plan/subscription-plan.component';
import { DailogComponent } from './widgets/dailog/dailog.component';
import { BannerActualViewComponent } from './widgets/banner-actual-view/banner-actual-view.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ProductUploadFailedComponent } from './widgets/product-upload-failed/product-upload-failed.component';
import { MobileViewComponent } from './widgets/mobile-view/mobile-view.component';
import { AlphabeticOnlyDirective } from './directives/alphabeticOnly.directive';
import { AmountFormatPipe } from './pipes/amountFormat.pipe';
import { NgxBarcodeModule } from 'ngx-barcode';
import { QrScannerComponent } from './widgets/qr-scanner/qr-scanner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { IntegrationComponent } from './widgets/user-profile/integration-profile/integration/integration.component';
import { MediaLinksComponent } from './widgets/user-profile/media/media-links.component';
import { HierarchyScopeSelectorComponent } from './widgets/hierarchy-scope-selector/hierarchy-scope-selector.component';
import { CatalogueTemplateComponent } from '../components/retail-store/catalogue/catalogue-template/catalogue-template.component';

@NgModule({
  declarations: [
    AreaComponent,
    CardComponent,
    PieComponent,
    ColumnChartComponent,
    PageTitleComponent,
    OnlyNumberDirective,
    AlphabeticOnlyDirective,
    TwoDigitDecimaNumberDirective,
    UserProfileComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    AssignedLicencesComponent,
    SubscriptionComponent,
    DeleteConfirmationComponent,
    ConfirmDailogComponent,
    BannerComponent,
    UploadComponent,
    TermConditionPageComponent,
    SubscriptionPlanComponent,
    DailogComponent,
    BannerActualViewComponent,
    ProductUploadFailedComponent,
    MobileViewComponent,
    AmountFormatPipe,
    QrScannerComponent,
    IntegrationComponent,
    MediaLinksComponent,
    HierarchyScopeSelectorComponent,
    CatalogueTemplateComponent,
  ],
  imports: [
    CommonModule,
    // FlexLayoutModule,
    RouterModule,
    HighchartsChartModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatAutocompleteModule,
    NotifierModule.withConfig(Config.notifierDefaultOptions),
    NgxBarcodeModule,
    ZXingScannerModule
  ],
  exports: [
    FormsModule,
    AreaComponent,
    CardComponent,
    PieComponent,
    ColumnChartComponent,
    PageTitleComponent,
    OnlyNumberDirective,
    AlphabeticOnlyDirective,
    TwoDigitDecimaNumberDirective,
    NotifierModule,
    UserProfileComponent,
    DeleteConfirmationComponent,
    ConfirmDailogComponent,
    BannerComponent,
    UploadComponent,
    TermConditionPageComponent,
    BannerActualViewComponent,
    ProductUploadFailedComponent,
    MobileViewComponent,
    AmountFormatPipe,
    QrScannerComponent,
    HighchartsChartModule,
    HierarchyScopeSelectorComponent,
    CatalogueTemplateComponent,
  ],
  entryComponents: [DeleteConfirmationComponent, ConfirmDailogComponent, BannerComponent, UploadComponent, BannerActualViewComponent, QrScannerComponent],
  providers: [DatePipe],
})
export class SharedModule { }
